
import { defineComponent, onMounted, provide, ref } from 'vue'
import Title from '@/components/common/Title.vue'
import Input from '@/components/common/Input.vue'
import SearchInput from '@/components/common/SearchInput.vue'
import CollapseMenu from '@/components/common/CollapseMenu.vue'
import Collapse from '@/components/common/Collapse.vue'
import store from '@/composition/store'
import { useRoute, useRouter } from 'vue-router'
import map from 'lodash/map'
export default defineComponent({
  name: 'g-faq-view',
  components: {
    Title,
    // Input,
    CollapseMenu,
    // SearchInput,
    Collapse
  },
  setup () {
    provide('store', store)
    const route = useRoute()
    const router = useRouter()
    const collapseMenu = ref()
    const selectItem = ref()
    const subSelectItem = ref()
    const selectId = ref(1)
    const selectTitle = ref('')
    const showList = ref([] as boolean[])
    const questionList = ref([] as any)
    const menuClick = (item: any) => {
      if (item.id > 2) {
        showList.value = []
      }
      selectItem.value = item.items
      showList.value[item.id] = !showList.value[item.id]
      console.log(selectItem.value)
      selectId.value = item.id
      selectTitle.value = item.title
      if (selectItem.value !== null && selectItem.value !== []) {
        if (collapseMenu.value === undefined) {
          collapseMenu.value = item.items[0]
          questionList.value = item.items[0].questionList
        }
      } else {
        collapseMenu.value = null
      }
    }
    const itemsClick = (item: any) => {
      questionList.value = item.questionList
    }
    const items = ref([
      {
        id: 1,
        title: '關於會員',
        items: [
          {
            id: '1-1',
            title: '註冊/登入相關',
            questionList: [
              {
                Id: 1,
                Question: '如何加入會員？',
                Answer:
                  '點擊 HORLaY 網站頁面右上角「會員登入/註冊」按鈕，即可進入註冊會員流程。',
                IsOpen: false
              },
              {
                Id: 2,
                Question: '沒收到簡訊驗證碼怎麼辦？',
                Answer:
                  '① 請再次確認輸入的手機號碼是否正確。<br/>② 請確認所在地收訊接收狀況，或等候1分鐘後再次重發。<br/>③ 請確認手機是否開啟「勿擾模式」，導致簡訊接收失敗。<br/>④ 請確認手機是否有安裝廣告阻擋/網路安全軟體。<br/>⑤ 請確認手機簡訊容量是否已達上限，建議刪除部分訊息後再次重發。',
                IsOpen: false
              },
              {
                Id: 3,
                Question: '忘記密碼怎麼辦？',
                Answer:
                  '請按照以下步驟操作，即可進入取回密碼流程。<br/>Step① 點擊 HORLaY 網站右上角「會員登入/註冊」按鈕。<br/>Step② 輸入註冊會員時使用的手機號碼，並點選「登入/註冊」。<br/>Step③ 點擊下方的「忘記密碼?」，系統將自動發送一封更改密碼的簡訊到您的手機。<br/>Step④ 輸入簡訊驗證碼，並點選「下一步」。<br/>Step⑤ 重新設定登入密碼後，即完成設定。<br/>(圖示教學)<br/><br/>✶提醒您：有鑑於個資保護法條規定，本公司人員皆無法查詢及變更您的密碼，請您妥善保管帳戶資料。',
                IsOpen: false
              },
              {
                Id: 4,
                Question: '無法順利「登入」怎麼辦？',
                Answer:
                  '請確認您的帳號/密碼是否正確，並請注意大小寫須符合原設定；亦可使用忘記密碼試試看。<br/><br/>若仍有問題，歡迎加入 <a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a> 填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              },
              {
                Id: 5,
                Question: '可以變更我的手機號碼嗎？',
                Answer:
                  'HORLaY 會員以手機號碼為註冊帳號，故完成註冊後將無法變更手機號碼。<br/><br/>若因為特殊情況或需求無法登入 HORLaY 帳號（例如：手機號碼已變更等），建議使用新的手機號碼註冊新帳號。<br/>✶提醒您：因帳號已更換，原帳號內的訂單或點數等資料，皆無法轉移至新帳號。',
                IsOpen: false
              },
              {
                Id: 6,
                Question: '如何更改我常用的收件地址？',
                Answer:
                  '登入 HORLaY 會員後，進入「會員專區」→「帳號設定」，點選「管理地址」即可編輯常用的收件地址，也可以刪除資料。',
                IsOpen: false
              },
              {
                Id: 7,
                Question: '如何修改我的電子郵件？',
                Answer:
                  '登入 HORLaY 會員後，進入「會員專區」→「帳號設定」，點選「基本設定」→「E-mail」即可進行編輯。',
                IsOpen: false
              },
              {
                Id: 8,
                Question: '如何變更帳戶資料或密碼？',
                Answer:
                  '登入 HORLaY 會員後，進入「會員專區」→「帳號設定」，點選「基本設定」或「變更密碼」即可重新設定。',
                IsOpen: false
              }
            ]
          }
        ]
      },
      {
        id: 2,
        title: '購物與訂單',
        items: [
          {
            id: '2-1',
            title: '購物相關',
            questionList: [
              {
                Id: 1,
                Question: '如何在 HORLaY 上購買商品？',
                Answer:
                  '<strong>一般商品訂購流程</strong><br/>Step① 請先註冊 HORLaY 會員<br/>Step② 選擇商品規格加入購物車<br/>Step③ 填寫訂購、配送資訊及付款<br/>Step④ 成立訂單<br/><br/><strong>個人訂製商品訂購流程</strong><br/>Step① 請先註冊 HORLaY 會員<br/>Step② 選擇商品規格、包裝樣式，點擊「開始訂製」<br/>Step③ 依步驟完成訂購內容，加入購物車<br/>Step④ 選擇「繼續編輯」訂製內容或「前往結帳」填寫訂購資訊及付款<br/>Step⑤ 成立訂單',
                IsOpen: false
              },
              {
                Id: 2,
                Question: '購物車內的商品可以分批結帳嗎？',
                Answer: '購物清單皆可選擇單樣或多樣商品進行結帳。',
                IsOpen: false
              },
              {
                Id: 3,
                Question: '已加入購物車的商品還能修改嗎？',
                Answer: '尚未完成結帳的商品皆可進行修改或編輯。',
                IsOpen: false
              },
              {
                Id: 4,
                Question: '放入購物車的商品可否取消？',
                Answer:
                  '在購物車中，找到想要取消的商品，點擊該品項右上角的「X」圖樣，即可刪除。<br/><br/>✶提醒您：<br/>① 購物車中移除的個人訂製商品仍會存放於「作品庫」中，可再次加入購物車。<br/>② 「作品庫」中僅保存個人訂製商品，客製化包裝一經刪除則須重新製作，方能再次加入購物車。',
                IsOpen: false
              },
              {
                Id: 5,
                Question: '如何查詢我的訂單？',
                Answer:
                  '點擊HORLaY 網站右上角「會員專區」→「訂單紀錄」，即可查詢訂單歷史紀錄。',
                IsOpen: false
              },
              {
                Id: 6,
                Question: '訂單成立後，可否取消或更改訂單數量及商品？',
                Answer:
                  '<strong>待付款訂單</strong><br/>訂單尚未付款成功前，請先取消訂單後再重新訂購商品及數量。<br/>✶取消訂單流程：「訂單紀錄」→「待付款」→「訂單詳情」→ 點選「取消訂單」<br/><br/><strong>已付款訂單</strong><br/>付款成功後，商品即進入製作階段，將無法再進行任何訂單內容變更。<br/><br/>若仍有問題，歡迎加入 <a href="https://router.vuejs.org" target="_blank" rel="noopener"><a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a></a> 或至「聯絡我們」填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              },
              {
                Id: 7,
                Question: '配送方式有哪些？',
                Answer:
                  '<strong>① 宅配</strong><br/><strong>② 超商取貨：7-11、全家、萊爾富</strong><br/><strong>③ 門店取貨</strong><br/><br/>出貨時間：週一至週五，遇假日不出貨。<br/>✶提醒您：商品實際交期以個別訂單為準。',
                IsOpen: false
              },
              {
                Id: 8,
                Question: '同一筆訂單的商品會一起到貨嗎？',
                Answer:
                  '同一筆訂單內商品，會依據工作天數較長的商品出貨日統一出貨。',
                IsOpen: false
              },
              {
                Id: 9,
                Question: '訂單成立後還能修改收件地址嗎？',
                Answer:
                  '若訂單狀態為「待付款」或「處理中」，請聯繫客服協助修改該筆訂單的收件資訊。若訂單狀態已變更為「待收貨」則無法再進行變更。<br/><br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              }
            ]
          },
          {
            id: '2-2',
            title: '付款相關',
            questionList: [
              {
                Id: 1,
                Question: '付款方式有哪些？',
                Answer: '① 信用卡<br/>② LINE PAY<br/>③ ATM轉帳',
                IsOpen: false
              },
              {
                Id: 2,
                Question: '若刷卡失敗，如何重新進行結帳？',
                Answer:
                  '訂單刷卡失敗時，該筆訂單將成立為「待付款」狀態，可點擊「會員專區」→「訂單紀錄」→「待付款」→「訂單詳情」→ 進行「再次付款」。<br/><br/>若仍有問題，歡迎加入 <a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a> 或至「聯絡我們」填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              },
              {
                Id: 3,
                Question: '訂單成立後，可否變更付款方式？',
                Answer:
                  '<strong>待付款訂單</strong><br/>訂單尚未付款成功前，請先取消訂單後再重新訂購，並選擇新的付款方式。<br/>✶取消訂單流程：「訂單紀錄」→「待付款」→「訂單詳情」→ 點選「取消訂單」<br/><br/><strong>已付款訂單</strong><br/>付款成功後，商品即進入製作階段，將無法再進行任何訂單內容變更。<br/><br/>若仍有問題，歡迎加入 <a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a> 或至「聯絡我們」填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              },
              {
                Id: 4,
                Question: '如何知道「轉帳」是否成功？',
                Answer:
                  '轉帳完成後，系統會自動進行對帳，約10分鐘後，即可至「會員專區」→「訂單紀錄」確認訂單狀態，若訂單狀態已變更為「處理中」即為匯款成功。<br/><br/>若仍有問題，歡迎加入 <a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a> 或至「聯絡我們」填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              },
              {
                Id: 5,
                Question: '忘記轉帳帳號怎麼辦？',
                Answer:
                  '登入 HORLaY 會員後，進入「會員專區」→「訂單紀錄」→「待付款」→「訂單詳情」→「付款方式」即可查詢轉帳帳號。',
                IsOpen: false
              },
              {
                Id: 6,
                Question: '已經付款了，為何訂單狀態仍為待付款？',
                Answer:
                  '在完成刷卡或轉帳步驟後，有時金流系統流量較壅塞，交易資訊無法立即回傳至訂單系統，如八小時後仍為待付款，請與客服聯繫確認，勿點選取消訂單。<br/><br/>歡迎加入 <a href="https://lin.ee/9wk6zF4" target="_blank" style="text-decoration: underline;">Line官方客服</a> 或至「聯絡我們」填寫需求，我們將於上班日盡快提供協助。<br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）',
                IsOpen: false
              }
            ]
          },
          {
            id: '2-3',
            title: '發票相關',
            questionList: [
              {
                Id: 1,
                Question: '如何查詢已開立的發票？',
                Answer:
                  '<strong>未歸戶(會員載具)</strong><br/>發票開立完成後， HORLaY 會寄發E-mail至您所填寫的會員信箱。<br/><br/><strong>已歸戶(手機載具/自然人憑證)</strong><br/>您可至「財政部電子發票整合服務平台」查詢到該發票資料。',
                IsOpen: false
              },
              {
                Id: 2,
                Question: '載具歸戶說明',
                Answer:
                  '發票載具歸戶是指將各種載具整合到「手機條碼憑證」或「自然人憑證」，可於「財政部電子發票整合服務平台」 統一管理及查詢無實體電子發票，且會主動進行發票對獎領獎相關通知及作業。<br/>✶載具歸戶流程：「會員專區」→「帳號設定」→ 點選「會員發票載具歸戶」<br/>✶提醒您：歸戶前需確認您已申請共通性載具（手機條碼憑證或自然人憑證）',
                IsOpen: false
              },
              {
                Id: 3,
                Question: '如何知道我的發票是否中獎？怎麼兌獎？',
                Answer:
                  '<strong>未歸戶</strong><br/>每逢單數月26日，若使用會員載具之發票中獎，將由 HORLaY 自動對獎後以E-mail通知中獎，並於10日內以掛號方式將發票正本寄送至您所填寫的會員地址。<br/><br/><strong>已歸戶</strong><br/>共通性載具(手機載具/自然人憑證)，二聯式發票中獎時，將由財政部統一通知中獎人。<br/><br/>✶提醒您：請確實填寫會員資料。若因資料填寫不完整或錯誤導致發票無法順利寄送或超過兌獎期間內送達，本公司將不受理補償及其他相關賠償責任。',
                IsOpen: false
              },
              {
                Id: 4,
                Question: '可以指定日期、開立其它品名？是否可以開立多筆發票？',
                Answer:
                  'HORLaY 全面採用系統自動開立發票，恕無法指定開立日期、其他品名或金額。',
                IsOpen: false
              },
              {
                Id: 5,
                Question: '發票是否可以加開抬頭？',
                Answer:
                  '配合財政部新版電子發票格式，電子發票證明聯無抬頭欄位，恕無法加開抬頭。',
                IsOpen: false
              },
              {
                Id: 6,
                Question: '發票開立錯誤如何處理？',
                Answer:
                  '電子發票開立後即無法變更，且更為配合國稅局勸止二聯換開三聯之政策，本公司有權利考量各因素後拒絕換開發票，請於訂購時確認應取得二聯或三聯(報帳用)發票。<br/><br/><strong>三聯式電子發票</strong><br/>當統編填寫錯誤時，請於發票開立次月5號前聯絡客服協助，逾期將不再受理修改、作廢及重新開立該訂單發票。如因此無法進行報帳等作業，本公司恕不受理補償及其他相關賠償責任。<br/><br/>✶提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定例假日除外）',
                IsOpen: false
              }
            ]
          },
          {
            id: '2-4',
            title: '售後服務相關',
            questionList: [
              {
                Id: 1,
                Question: '退換貨須知',
                Answer:
                  '① 有瑕疵而欲退貨時，請於七日內提出，並需保持退回物品的完整性，如數量、包裝、或附件皆須與下單內容一致，否則恕不予以退貨、銷帳。<br/>② 退貨受理時間：上班日09:00-12:00、13:00-18:00（國定假日除外），逾時或逾期恕不予受理。<br/>③ 印刷色差值「±10%」內均屬正常合理範圍，恕不得以此作為退換貨理由。<br/>④ 若因您上傳的照片、圖片解析度不足，而導致印出成品與網站預覽圖有差異時，並不屬於印刷瑕疵，恕不接受退貨。<br/>⑤ 個人訂製商品/包裝，如因本公司疏失導致商品瑕疵時，一律以您的原設計及訂製條件再次重製商品，恕無法提供退貨及不接受任何修改圖檔及變更訂製條件，且不負擔其他衍生費用，敬請見諒。',
                IsOpen: false
              },
              {
                Id: 2,
                Question: '如何處理瑕疵或錯誤商品？',
                Answer:
                  '<strong>一般商品</strong><br/>依據消費者保護法規商品到貨享七天猶豫期之權益。請於收到貨當日起算7日猶豫期內（含國定例假日）聯繫客服，並提供以下資料至客服信箱( service@horlay.com )，我們將在收到您的信件後盡快提供協助，逾時恕不予受理。<br/><br/>𝐀. 您的訂單編號<br/>𝐁. 退貨原因<br/>𝐂. 您的姓名、聯絡電話、地址<br/>𝐃. 白天方便聯絡的時間<br/><br/>✶ 猶豫期非試用期！商品必須是「未經使用」全新狀態且包裝、配件內容、數量都與下單內容一致（包含外包裝、贈品等），否則將會影響退貨權益。<br/>✶ 為確保雙方權益，拆封包裹時請務必全程錄影存證。<br/><br/><br/><strong>個人訂製商品/包裝</strong><br/>① 依據消費者保護法第19條「客製化商品」不適用七天鑑賞期間（猶豫期）規定，非人為損壞之缺頁、掉頁、 裁切不齊、印刷污損與其他可歸責於本公司之情況，恕不接受以不喜歡設計或其他原因為由退貨、退款或換貨， 請您慎重選購。<br/>② 所訂購商品如發生非消費者個人因素之商品損毀、刮傷、髒污，或發生裝訂錯誤、缺頁、 裁切不齊、印刷污損與其他可歸責於本公司之情況，請您於收到商品的7日內，以照片或影片方式記錄瑕疵發生情形。並將以下資料mail至客服信箱( service@horlay.com )，我們將在收到您的信件後盡快提供協助。<br/><br/>𝐀. 您的訂單編號<br/>𝐁. 商品名稱<br/>𝐂. 商品瑕疵情形的照片或影片檔案<br/>𝐃. 您的姓名、聯絡電話、地址<br/>𝐄. 白天方便聯絡的時間<br/><br/>✶ 提醒您：客服上班日為週一至週五 09:00-12:00、13:00-18:00（國定假日除外）<br/><br/>③ 個人訂製商品/包裝，如因本公司疏失導致商品瑕疵時，一律以您的原設計及訂製條件再次重製商品，恕不接受任何修改圖檔及變更訂製條件，且不負擔其他衍生費用，敬請見諒。',
                IsOpen: false
              },
              {
                Id: 3,
                Question: '退貨後退款時間需多久？',
                Answer:
                  '商品退回至 HORLaY 約需3-7個工作天（國定假日除外），HORLaY 收到後將會先確認商品是否正確、完整，確認無誤後即進入相關退費流程，款項將依原付款方式退款，退款作業時間約7-14個工作天。',
                IsOpen: false
              },
              {
                Id: 4,
                Question: '辦理退貨是全額退款嗎？',
                Answer:
                  '<strong>一般商品</strong><br/>七日猶豫期內，取消或辦理商品退貨，HORLaY 將退還您實際所支付的金額並扣除運費後之總額。若原訂單享有免運折扣，經退貨品項及金額核算後，如最終購物車金額未達免運活動門檻時，運費須由消費者負擔，退款金額將以欲退貨商品實際總支付金額扣除運費後計算。<br/><br/>✶ 提醒您：由於所有個人訂製商品/包裝皆是您專屬的創意作品，不適用七日猶豫期且恕不接受退款退貨。',
                IsOpen: false
              },
              {
                Id: 5,
                Question: '辦理退貨需支付運費嗎？',
                Answer:
                  '<strong>一般商品</strong><br/>七日猶豫期內，單筆訂單僅限申請一次退貨，退貨運費由 HORLaY 負擔。<br/><br/>✶ 提醒您：由於所有個人訂製商品/包裝皆是您專屬的創意作品，不適用七日猶豫期且恕不接受退款退貨。',
                IsOpen: false
              }
              // {
              //   Id: 6,
              //   Question: '使用折扣碼，退貨退款後還可以使用嗎？',
              //   Answer:
              //     '折扣碼為 HORLaY 官網獨享優惠，一經使用後立即失效（包含自行取消、超過付款期限被系統取消），將無法再次使用該組折扣碼且無法補發，請謹慎使用。<br/><br/>✶ 提醒您：HORLaY 保留變更與取消活動之權利。',
              //   IsOpen: false
              // }
            ]
          }
        ]
      },
      {
        id: 3,
        title: '服務使用條款',
        items: null
      },
      {
        id: 4,
        title: '隱私權政策及條款',
        items: null
      },
      {
        id: 5,
        title: '委託製作契約',
        items: null
      }
    ])
    const getSelected = () => {
      const _Id = route.query.Id as any
      const _SubId = route.query.SubId
      const QAId = route.query.QAId
      if (_Id === undefined) {
        menuClick(items.value[0])
      } else {
        if (parseInt(_Id) < 3) {
          if (_SubId === undefined) {
            menuClick(items.value[_Id - 1])
          } else {
            items.value.forEach((element) => {
              element.items?.forEach((item) => {
                if (_SubId !== undefined && item.id === _SubId) {
                  showList.value[element.id] = !showList.value[element.id]
                  selectItem.value = element
                  collapseMenu.value = item
                  if (QAId !== undefined) {
                    questionList.value = map(item.questionList, (qa: any) => {
                      if (qa.Id.toString() === QAId) {
                        qa.IsOpen = true
                      }
                      return qa
                    })
                  }
                }
              })
            })
          }
        } else {
          menuClick(items.value[_Id - 1])
        }
      }
    }
    onMounted(() => {
      getSelected()
    })
    return {
      store,
      items,
      selectId,
      selectTitle,
      collapseMenu,
      selectItem,
      subSelectItem,
      showList,
      questionList,
      menuClick,
      itemsClick,
      getSelected
    }
  }
})
